import { groupBy } from "@/shared/v2/utils/helpers";
import { TableFilterValues, TableSort, TableSortValues } from "./types";

export const generateSortValue = (
  value: TableSortValues
): TableSortValues | undefined => {
  if (value === "ASC_NUMERIC") return "DESC_NUMERIC";
  if (value === "DESC_NUMERIC") return undefined;
  if (value === "ASC") return "DESC";
  if (value === "DESC") return undefined;
};

export const generateSort = (
  id: string,
  active: boolean,
  group?: string,
  index?: any[],
  isNumeric: boolean = false,
  reset: string[] = []
): TableSort => {
  return {
    id,
    value: isNumeric
      ? active
        ? "DESC_NUMERIC"
        : "ASC_NUMERIC"
      : active
      ? "DESC"
      : "ASC",
    group,
    index,
    reset,
  };
};

export const mapSort = (currentSort: TableSort[], sort: TableSort) => {
  const doesSortExist = currentSort.find((c) => c.id === sort.id) !== undefined;
  const filtered = currentSort.filter(
    (current) => !sort.reset.includes(current.id)
  );

  if (!doesSortExist) return [...filtered, sort];
  return filtered
    .map((c) =>
      c.id === sort.id ? { ...c, value: generateSortValue(c.value) } : c
    )
    .filter((c) => c.value !== undefined);
};

export const mapFilters = (
  currentFilters: TableFilterValues[],
  filter: TableFilterValues
) => {
  let v = filter.value.length === 0 ? undefined : filter;
  const doesSortExist =
    currentFilters?.find((c) => c?.id === filter?.id) !== undefined;
  if (!doesSortExist)
    return v === undefined ? currentFilters : [...currentFilters, v];

  return currentFilters
    .map((c) => (c.id === filter.id ? filter : c))
    .filter((c) => {
      return Array.isArray(c.value) ? c.value.length !== 0 : c.value !== "";
    });
};

export const removeAtIndex = (arr, index) => {
  const copy = [...arr];
  copy.splice(index, 1);
  return copy;
};

export const toggle = (arr: any[], item: any, getValue = (item) => item) => {
  const index = arr.findIndex((i) => getValue(i) === getValue(item));
  if (index === -1) return [...arr, item];
  return removeAtIndex(arr, index);
};

export function searchTree(tree, targetValue) {
  // If the current node matches the target value, return the node
  if (tree === targetValue) {
    return tree;
  }

  // If the current node is an object or array, iterate through its properties/elements
  if (typeof tree === "object" && tree !== null) {
    for (const key in tree) {
      const result = searchTree(tree[key], targetValue);
      if (result) {
        return result; // Return the node if found
      }
    }
  }

  // Return null if the target value is not found
  return null;
}

export const keyFilters = (filters: TableFilterValues[]) => {
  const grouped = groupBy(filters, "table");
  return grouped;
};
